export class ExtratoAtlasConselhoFiscal {

    static extratoAtlasConselhoFiscalLista: ExtratoAtlasConselhoFiscal[] = [
        // { tipo: 'pdf', descricao: 'extrato_ata _conse_605 _27.11.2020', caminho: '', ano: 2020 }
        { tipo: 'pdf', descricao: 'Extrato_Ata_4Reuniao_Ordinaria_28.4.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_5Reuniao_Ordinaria_Maio2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_6Reuniao_Ordinaria_junho2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_7Reuniao_Ordinaria_julho2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_8Reuniao_Ordinaria_agosto_2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_8Reuniao_Ordinaria_setembro_2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_10Reuniao_Ordinaria_Outubro2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_11Reuniao_Ordinaria_Novembro2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_12Reuniao_Ordinaria_Dezembro2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'ExtratoAta01_ReuniaoOrdinaria_Janeiro2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta02_ReuniaoOrdinaria_fev2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta03_ReuniaoOrdinaria_mar2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta04_ReuniaoOrdinaria_abril2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta05_ReuniaoOrdinsria_maio2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta06_ReuniaoOrdinaria_junho2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta07_ReuniaoOrdinaria_julho2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta08_ReuniaoOrdinaria_agosto2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta09_ReuniaoOrdinaria_setembro2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta10_ReuniaoOrdinaria_outubro2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta11_ReuniaoOrdinaria_novembro2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta12_ReuniaoOrdinaria_dezembro2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAta01_ReuniaoOrdinaria_janeiro2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta02_ReuniaoOrdinaria_2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta03_ReuniaoOrdinaria_2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta04_ReuniaoOrdinaria_mar2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta05_ReuniaoOrdinaria_abr2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta06_ReuniaoOrdinaria_mai2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta07_ReuniaoOrdinaria_jun2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta08_ReuniaoOrdinaria_jul2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta09_ReuniaoOrdinaria_ago2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta10_ReuniaoOrdinaria_set2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta11_ReuniaoOrdinaria_out2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta12_ReuniaoOrdinaria_nov2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta13_ReuniaoOrdinaria_dez2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'ExtratoAta01_ReuniaoOrdinaria_jan2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta02_ReuniaoOrdinaria_fev2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta03_ReuniaoOrdinaria_mar2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta04_ReuniaoOrdinaria_mar2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta05_ReuniaoOrdinaria_abr2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta06_ReuniaoOrdinaria_mai2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta07_ReuniaoOrdinaria_jun2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta08_ReuniaoOrdinaria_jul2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta09_ReuniaoOrdinaria_ago2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta10_ReuniaoOrdinaria_set2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta11_ReuniaoOrdinaria_out2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta12_ReuniaoOrdinaria_nov2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta13_ReuniaoOrdinaria_dez2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'ExtratoAta01_ReuniaoOrdinaria_jan2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'ExtratoAta02_ReuniaoOrdinaria_fev2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'ExtratoAta03_ReuniaoOrdinaria_mar2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'ExtratoAta04_ReuniaoOrdinaria_abr2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'ExtratoAta05_ReuniaoOrdinaria_abr2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'ExtratoAta06_ReuniaoOrdinaria_mai2025', caminho: '', ano: 2025 },
    ];


    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string,
        public ano: number
    ) {

    }




}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/extrato-atas-conselho-fiscal.ts